import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { WebTableDataset } from 'app/model/dataset/web-table.dataset';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.webTable.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(WebTableDataset) }
})
export class WebCopySource extends CopySource {
}
